import { MenuButton, type MenuButtonProps } from '@chakra-ui/react';

export type UiMenuButtonProps = MenuButtonProps;

export const UiMenuButton = MenuButton;
